<script setup lang="ts">
import { getCorrectnessActionGroups } from '@/helpers/constants'
import type { CorrectnesGroups } from '@/types/basic'
import type { StreetActionsWithCorrectness } from '@/types/api/reports'

interface StreetActionProps {
  actions: StreetActionsWithCorrectness[]
  renameToBet?: boolean
}

const props = defineProps<StreetActionProps>()

const getAction = (actions: StreetActionsWithCorrectness[]) => {
  const cgs = getCorrectnessActionGroups() as CorrectnesGroups
  const res = actions
    .map(a => {
      const correctnessStr = (
        a.correctness === 'UNSOLVED' ? 'na' : a.correctness || ''
      ).toLowerCase()
      const correctness = cgs[correctnessStr]
      const action_id = a.action_code.substring(0, 1)
      return correctness
        ? `<span style="color:var(${correctness.color})">${action_id}</span>`
        : action_id
    })
    .join(' ')

  return props.renameToBet ? res.replace(/R/g, 'B') : res
}
</script>

<template>
  <div
    v-if="actions.length > 0"
    class="street-container"
  >
    <span v-html="getAction(actions)"></span>
  </div>
</template>

<style lang="scss" scoped>
.street-name {
  letter-spacing: 0px;
  position: relative;
  display: flex;
  align-items: center;
  line-height: 1;
  color: var(--clr-grey-2);
  &::first-letter {
    text-transform: capitalize !important;
  }
  font-size: 0.8rem;
  height: 0.7rem;
  margin-bottom: 0.125rem;
}

.street-container {
  position: relative;
  padding: 0 1rem 0 0;
  max-height: 2.2rem;
  letter-spacing: -0.5px;
  font-size: 0.925rem;
  line-height: 1;
  font-weight: 500;
  word-wrap: none;
  white-space: nowrap;
}
</style>
